import Alpine from 'alpinejs'

/**
 * Fix Formie's Stripe dynamic-amount float precision bug.
 */
const patchFormieStripeAmountRounding = () => {
    const Provider = window.FormieStripe

    if (!Provider || !Provider.prototype || typeof Provider.prototype.checkDynamicValues !== 'function') {
        return false
    }

    if (Provider.prototype.__amountRoundingPatched) {
        return true
    }

    const original = Provider.prototype.checkDynamicValues
    Provider.prototype.checkDynamicValues = function (...args) {
        const result = original.apply(this, args)

        const amount = this.paymentInformation?.amount
        if (typeof amount === 'number' && Number.isFinite(amount)) {
            this.paymentInformation.amount = Math.round(amount)
        }

        return result
    }
    Provider.prototype.__amountRoundingPatched = true

    return true
}

// FormieStripe is injected asynchronously with the payment field, so poll briefly until it exists.
const ensureFormieStripeAmountFix = () => {
    if (patchFormieStripeAmountRounding()) {
        return
    }

    let tries = 0
    const timer = setInterval(() => {
        tries += 1
        if (patchFormieStripeAmountRounding() || tries > 100) {
            clearInterval(timer)
        }
    }, 100)
}
ensureFormieStripeAmountFix()

// Donate Form - Dynamic Amounts
const Donate =()=>({
    choostype: 'Once',
    enteramount: '',
    selectedamount: '',
    singledynamicamounts: [],
    monthlydynamicamounts: [],
    selectedDesc: '',
    paymentMethodOnce:'cc-stripe-once',
    form: document.querySelector('.donateFormEL'),
    percentageBaseddonateOptionsArr:[],
    coverPlatformCosts:1,// yes
    selectedplatformcosts:'',
    totalamount:0,
    isUpdatingFromEnter: false, // Flag to prevent circular updates
    currencyFormatter (){
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    },
    percentageBaseddonateOptions(donationAmount){
        /**
         * Calculate available processing fee options for a donation
         *
         * Rules:
         * - Fees are percentage-based
         * - Higher donations expose fewer % options
         * - A hard maximum fee of $40 applies
         * - Fees are rounded to 2 decimal places
         *
         * @param {number} donationAmount
         * @returns {number[]} fee options
         */
            if (!Number.isFinite(donationAmount) || donationAmount <= 0) {
                return [];
            }

            // Percentage tiers (decimals)
            const TIERS = [
                0.031, // 3.1%
                0.043, // 4.3%
                0.055, // 5.5%
                0.078, // 7.8%
                0.101  // 10.1%
            ];

            const MAX_FEE = 40;

            let allowedTiers;

            if (donationAmount <= 200) {
                allowedTiers = TIERS;
            } else if (donationAmount <= 500) {
                allowedTiers = TIERS.filter(t => t <= 0.078);
            } else if (donationAmount <= 1000) {
                allowedTiers = TIERS.filter(t => t <= 0.055);
            } else {
                // For large donations, only the lowest tier is offered
                allowedTiers = [0.031];
            }
            const formatter = new Intl.NumberFormat('en-US', {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            // Calculate, round, and apply max fee
            const fees = allowedTiers.map(tier => {
                const fee = donationAmount * tier;
                const capped = Math.min(fee, MAX_FEE);
                return formatter.format(capped);
            });

            return [...new Set(fees)];
    },
    init(){
        const suggestedAmounts = this.form.querySelector('[data-suggested-amount]').getAttribute('data-suggested-amount');
        const parsedJsonAmounts = JSON.parse(suggestedAmounts);

        this.singledynamicamounts = parsedJsonAmounts.single;
        this.monthlydynamicamounts = parsedJsonAmounts.monthly;
        // Inital Selected
        this.selectedamount = parsedJsonAmounts.single[0].a * 1;
        this.selectedDesc = parsedJsonAmounts.single[0].d != '' ? `<p>$${parsedJsonAmounts.single[0].a} ${parsedJsonAmounts.single[0].d}</p>` : '';
        this.percentageBaseddonateOptionsArr = this.percentageBaseddonateOptions(parsedJsonAmounts.single[0].a * 1);

        this.selectedplatformcosts = this.percentageBaseddonateOptionsArr?.at(-1) ?? 0;
        this.totalamount = (parsedJsonAmounts.single[0].a * 1) + (this.selectedplatformcosts * 1);

        // selected first element
        this.$watch('choostype',(value)=>{
            this.enteramount = ''; // reset custom amount
            this.selectedamount = ''; // reset
            if(value == 'Monthly'){
                this.selectedamount = parsedJsonAmounts.monthly[0].a * 1;
                this.selectedDesc = parsedJsonAmounts.monthly[0].d != '' ? `<p>$${parsedJsonAmounts.monthly[0].a} ${parsedJsonAmounts.monthly[0].d}</p>` : '' ;
            }else{
                this.selectedamount = parsedJsonAmounts.single[0].a * 1;
                this.selectedDesc = parsedJsonAmounts.single[0].d != '' ? `<p>$${parsedJsonAmounts.single[0].a} ${parsedJsonAmounts.single[0].d}</p>` : '' ;
            }
        });
        this.$watch('enteramount',(value)=>{
            if(value && value.toString().trim() !== '') {
                this.isUpdatingFromEnter = true;
                this.selectedamount = value.toString();
                this.$nextTick(() => {
                    this.isUpdatingFromEnter = false;
                });
            }
        });
        this.$watch('selectedamount',(value)=>{
            // Clear enteramount when selecting preset (not when updated from enteramount)
            if (!this.isUpdatingFromEnter && this.enteramount) {
                this.enteramount = '';
            }

            // Set dynamic desc
            const correctArrAmountsArr = [...this.singledynamicamounts, ...this.monthlydynamicamounts];
            const match =  correctArrAmountsArr.find(item => item.a.toString() == value.toString());
            if (match) {
                this.selectedDesc = match.d != '' ? `<p>$${match.a} ${match.d}</p>` : '';
            } else {
                this.selectedDesc = '';
            };
            // Calculate percentage based opts
            let plaArr = this.percentageBaseddonateOptions(value * 1);
            this.percentageBaseddonateOptionsArr = plaArr;
            this.selectedplatformcosts = plaArr?.at(-1) ?? 0;
            // totalAmount
            this.totalamount = value * 1;
        });
        this.$watch('selectedplatformcosts',(value)=>{
            this.totalamount = (this.selectedamount * 1) + ((this.coverPlatformCosts * 1) * (this.selectedplatformcosts * 1));
            // Keep the hidden platformCostAmount in sync with the selected dropdown value
            this.syncPlatformCostAmount();
        });
        this.$watch('coverPlatformCosts',(value)=>{
            this.totalamount = (this.selectedamount * 1) + ((this.coverPlatformCosts * 1) * (this.selectedplatformcosts * 1));
            // When opting out of covering costs, platformCostAmount must be 0; otherwise use the selected value
            this.syncPlatformCostAmount();
        });
        // on form submit
        document.addEventListener('onFormieInit', (e) => {
            let Formie = e.detail.formie;
            if(this.form){
                this.form.addEventListener("onAfterFormieSubmit", this.onAfterSubmit.bind(this));
            }
        });

        // Reflect the initial selected platform cost into the hidden field
        this.$nextTick(() => {
            this.syncPlatformCostAmount();
        });
    },
    /**
     * Sync the platformCostAmount hidden field:
     * - cover platform costs = No/false  -> 0
     * - cover platform costs = Yes/true  -> the selected value from the donation-test dropdown
    */
    syncPlatformCostAmount() {
        const platformCostAmount = this.form?.querySelector("input[name='fields[platformCostAmount]']");
        if(platformCostAmount){
            platformCostAmount.value = (this.coverPlatformCosts * 1) ? this.selectedplatformcosts : 0;
            // Notify any listeners (Formie/validation) that the value changed
            platformCostAmount.dispatchEvent(new Event('input', { bubbles: true }));
        }
    },
    onAfterSubmit(e) {
        // set Value for formie
        const fieldAmount =  this.form.querySelector("input[name='fields[amount]']");
        if(fieldAmount){
          fieldAmount.value = this.selectedamount;
        }
         // set debitdAmount & platformCostAmount for formie
        const debitdAmount =  this.form.querySelector("input[name='fields[debitAmount]']");
        if(debitdAmount){
          debitdAmount.value = this.totalamount * 1;
        }
        this.syncPlatformCostAmount();
    },
})


document.addEventListener('alpine:init',()=>{
  Alpine.data('donate', Donate)
})